import type { ModalSteps } from "@/features/card/components/OnboardingModal";
import {
  CardWelcomeSlideHeader,
  CardActivationSlideHeader,
  CardActivationSuccessSlideHeader,
} from "@/features/card/components/OnboardingModal/OnBoardingModalElements/OnboardingModalSteps";
import type { YeatiesConsent } from "@/features/purchasePoints";

type OnboardingModalContentProps = {
  modalStep: ModalSteps
  isCardFlipped: boolean
  activationError: string | null
  consent: YeatiesConsent | null
};

export const OnboardingModalHeader = ({
  modalStep,
  activationError,
  consent,
}: OnboardingModalContentProps) => {
  const renderNewCardState = () => <CardWelcomeSlideHeader />;

  const renderCardActivationState = () => (
    <CardActivationSlideHeader activationError={activationError} />
  );

  const renderCardSuccessState = () => <CardActivationSuccessSlideHeader consent={consent} />;

  const slides = {
    "new-card": renderNewCardState,
    "card-activation": renderCardActivationState,
    "card-success": renderCardSuccessState,
  };

  return slides[modalStep]();
};
